export default __webpack_public_path__ + "1a436a6fac8382134f4d0d43e9fa7752.svg";